<div class="ricerca">
  <input #cerca (keyup)="onChange(cerca.value)" class="input" placeholder="Ricerca prodototto...">
  <button class="button" (click)="sendRicerca()">Cerca</button>
</div>
